"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBVRatings = exports.getBVApi = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _autobahnUtilities = require("@gcc/autobahn-utilities");

var _axios = _interopRequireDefault(require("axios"));

var getBVApi = function getBVApi(bvConversationsApiUrl, productId) {
  return new Promise(function (resolve) {
    (0, _autobahnUtilities.getScript)(bvConversationsApiUrl).then(function () {
      var _window = window,
          $BV = _window.$BV;

      if ($BV) {
        $BV.configure('global', {
          productId: productId
        });
        resolve();
      }
    });
  });
};

exports.getBVApi = getBVApi;

var getBVRatings = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var _response$data;

    var bvApiUrl, bvPasskey, productId, params, url, response, _response$data$Result, _response$data$Result2, data;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            bvApiUrl = _ref.bvApiUrl, bvPasskey = _ref.bvPasskey, productId = _ref.productId;
            params = {
              apiversion: '5.4',
              passkey: bvPasskey,
              filter: "Id:".concat(productId),
              stats: 'Questions,Reviews,Answers'
            };
            url = bvApiUrl.substr(0, bvApiUrl.lastIndexOf('?') < 0 ? bvApiUrl.length : bvApiUrl.lastIndexOf('?'));
            _context.next = 5;
            return _axios["default"].get(url, {
              params: params
            });

          case 5:
            response = _context.sent;
            _response$data$Result = response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.Results, _response$data$Result2 = (0, _slicedToArray2["default"])(_response$data$Result, 1), data = _response$data$Result2[0];

            if (!data) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return", {
              totalAnswerCount: data.TotalAnswerCount,
              totalQuestionCount: data.TotalQuestionCount,
              totalReviewCount: data.TotalReviewCount,
              starRating: data.ReviewStatistics.AverageOverallRating
            });

          case 9:
            return _context.abrupt("return", null);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getBVRatings(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.getBVRatings = getBVRatings;